import { autoinject } from "aurelia-framework";
import { BaseRangeRuleEditor } from "./base-range-rule-editor";
import { TreeNode } from "../tree-node";
import { TemperatureScales, TemperatureConverter } from "../../../converters/temperature-value";
import { Api } from "../../../services/api";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";

@autoinject
export class TemperatureRuleEditor extends BaseRangeRuleEditor {

	temperatureScale: string;

	constructor(api: Api, toastService: MdToastService, i18n: I18N) {
		super(api, toastService, i18n);
		this.temperatureScale = this.getTemperatureSymbol();
	}

	activate(model: any) {
		this.treeNode = model.selectedNode;
		this.property = model.property;

		const data = model.property.value.split(",");

		if (data.length === 4) {
			this.recommendedMinimum = this.convertTemperature(data[0]);
			this.requiredMinimum = this.convertTemperature(data[1]);
			this.requiredMaximum = this.convertTemperature(data[2]);
			this.recommendedMaximum = this.convertTemperature(data[3]);
		}

		if (data.length === 2) {
			this.requiredMinimum = this.convertTemperature(data[0]);
			this.requiredMaximum = this.convertTemperature(data[1]);
		}
	}

	getTemperatureScale() {
		let scale = localStorage.getItem("temperature-scale");
		if (!scale) {
			scale = TemperatureScales.fahrenheit;
		}
		return scale;
	}

	getTemperatureSymbol(): string {
		let scale = this.getTemperatureScale();
		switch (scale) {
		case TemperatureScales.fahrenheit:
			return "°F";
		case TemperatureScales.celsius:
			return "°C";
		default:
			return "°F";
		}
	}

	convertTemperature(temperature: number) {
		let scale = this.getTemperatureScale();
		switch (scale) {
		case TemperatureScales.celsius:
			return temperature;
		case TemperatureScales.fahrenheit:
				return this.round(TemperatureConverter.toFahrenheit(temperature), 1);
		default:
				return this.round(TemperatureConverter.toFahrenheit(temperature), 1);
		}
	}

	convertTemperatureBack(temperature: number) {
		let scale = this.getTemperatureScale();
		switch (scale) {
		case TemperatureScales.celsius:
			return temperature;
		case TemperatureScales.fahrenheit:
			return TemperatureConverter.toCelsius(temperature);
		default:
			return TemperatureConverter.toCelsius(temperature);
		}
	}

	round(value: number, precision: number): number {
		const multiplier = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}

	async applyChanges() {
		const data = `${this.convertTemperatureBack(this.recommendedMinimum)},${this.convertTemperatureBack(this.requiredMinimum)},${this.convertTemperatureBack(this.requiredMaximum)},${this.convertTemperatureBack(this.recommendedMaximum)}`;
		const result = await this.addOrUpdateProperty(data);
	}

	async delete() {
		const result = await super.deleteProperty(this.property);
	}
}
